"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const TransactionTypeResolver_1 = require("./services/TransactionTypeResolver");
const CryptoService_1 = require("./services/CryptoService");
const TransactionSerializer_1 = require("./services/TransactionSerializer");
const StorageService_1 = require("./services/StorageService");
const TransportService_1 = require("./services/TransportService");
const ValidatorService_1 = require("./services/ValidatorService");
const IgnoreAndBlockFilterService_1 = require("./services/IgnoreAndBlockFilterService");
const TransactionService_1 = require("./services/TransactionService");
const UserService_1 = require("./services/UserService");
const IgnoreAndBlockControlService_1 = require("./services/IgnoreAndBlockControlService");
// noinspection JSUnusedGlobalSymbols
class RegularDecentralizedApplication {
    constructor(namespace, connectionsPool, maxSignaturesNumber = 5) {
        this.namespace = namespace;
        this.connectionsPool = connectionsPool;
        this.maxSignaturesNumber = maxSignaturesNumber;
        this.transactionTypeResolver = new TransactionTypeResolver_1.TransactionTypeResolver();
        this.cryptoService = new CryptoService_1.CryptoService(this.transactionTypeResolver);
        this.transactionSerializer = new TransactionSerializer_1.TransactionSerializer(this.transactionTypeResolver);
        this.storageService = new StorageService_1.StorageService(this.namespace, this.transactionSerializer);
        this.transportService = new TransportService_1.TransportService(this.connectionsPool, this.transactionSerializer, this.namespace);
        this.validatorService = new ValidatorService_1.ValidatorService(this.cryptoService, this.transactionTypeResolver);
        this.ignoreAndBlockControlService = new IgnoreAndBlockControlService_1.IgnoreAndBlockControlService(this.storageService);
        this.ignoreAndBlockFilterService = new IgnoreAndBlockFilterService_1.IgnoreAndBlockFilterService(this.storageService);
        this.transactionService = new TransactionService_1.TransactionService(this.cryptoService, this.transportService, this.storageService, this.validatorService, this.ignoreAndBlockControlService, this.ignoreAndBlockFilterService, this.maxSignaturesNumber);
        this.userService = new UserService_1.UserService(this.cryptoService, this.transactionService);
    }
    // noinspection JSUnusedGlobalSymbols
    startNetworking(onNewTransactionsCallback, broadcastInterval) {
        this.transactionService.addOnNewTransactionsCallback(onNewTransactionsCallback);
        const transactionService = this.transactionService;
        window.setInterval(() => __awaiter(this, void 0, void 0, function* () {
            yield transactionService.broadcastTransactions();
        }), broadcastInterval);
    }
}
exports.RegularDecentralizedApplication = RegularDecentralizedApplication;
